const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ["year", 31_536_000],
  ["month", 2_592_000],
  ["day", 86_400],
  ["hour", 3_600],
  ["minute", 60],
];

export function formatRelativeTime(
  iso: string,
  locale: string,
  now: number = Date.now(),
) {
  const seconds = Math.round((new Date(iso).getTime() - now) / 1000);
  const formatter = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  const [unit, size] = UNITS.find(([, s]) => Math.abs(seconds) >= s) ?? [
    "second",
    1,
  ];
  return formatter.format(Math.trunc(seconds / size), unit);
}
